import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GenericTypeService } from 'src/app/services/generic-type/generic-type.service';
import { LS } from 'src/app/helpers/localStorage.enum';
import { GenericTypeStoreService } from 'src/app/stores/generic-types-store/generic-type-store.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
})
export class HomeComponent implements OnInit, OnDestroy {
  isSpotlight
  gTypeServiceSub: Subscription;
  logo;
  currentUser

  constructor(
    private gTypeService: GenericTypeService,
    private genericTypeStore: GenericTypeStoreService
  ) {
    this.gTypeServiceSub = this.gTypeService.findAll().subscribe((res) => {
      this.genericTypeStore.setGenericTypes = res.data;
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser))
    this.logo = this.currentUser.organisation?.logo_url
  }

  ngOnDestroy() {
    this.gTypeServiceSub.unsubscribe()
  }
  
  onSpotlightToggle($event) {
    this.isSpotlight = $event
  }
}
